export default __webpack_public_path__ + "static/media/arrow-right.b3d62e41.svg";